import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Decimal from 'decimal.js';

@Pipe({
  name: 'vxCurrency',
  standalone: true,
  pure: true,
})
export class VxCurrencyPipe implements PipeTransform {
  translateService = inject(TranslateService);

  transform(value: string | number | undefined | null | Decimal, hideCurrency?: boolean) {
    const valueNumber = this.normalizeValue(value);
    if (valueNumber == null) {
      return '';
    }
    const locale = this.translateService.getCurrentLang();

    return new Intl.NumberFormat(locale, {
      style: hideCurrency ? 'decimal' : 'currency',
      currency: 'LYD',
      currencyDisplay: 'symbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(valueNumber);
  }

  normalizeValue(value: string | number | undefined | null | Decimal): number | undefined {
    if (value === undefined || value === null) {
      return undefined;
    }
    if (typeof value === 'number') {
      return value;
    }
    if (value instanceof Decimal) {
      return value.toNumber();
    }
    if (typeof value === 'string') {
      const parsedValue = parseFloat(value.replace(/[^0-9.-]+/g, ''));
      return isNaN(parsedValue) ? undefined : parsedValue;
    }
    return undefined;
  }
}
